import React from 'react';
import styled from 'styled-components';

import { ContactUs } from '@manulife/mux';

const styledLink = styled.a`
    text-decoration: none;
`;

export const GetHeaderRightItems = (language) => {
    const ariaLabel =
        language === 'fr-CA' ? 'Communiquez avec nous ouvre un nouvel onglet' : 'Contact us open in a new tab';
    const href =
        language === 'fr-CA'
            ? 'https://www.manuvie.ca/particuliers/soutien/regimes-collectifs/assurance-collective.html'
            : 'https://www.manulife.ca/personal/support/group-plans/group-benefits.html';

    return [
        <ContactUs
            key="contact-us"
            as={styledLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabel}
            href={href}
        />,
    ];
};

export const GetFooterItems = (language) =>
    language === 'fr-CA'
        ? [
              {
                  id: 'manulifeCanada',
                  label: 'Manuvie Canada',
                  ariaLabel: 'Manuvie Canada',
                  title: 'Manuvie Canada',
                  href: 'https://www.manulife.com/fr.html',
                  isExternal: true,
              },
              {
                  id: 'legal',
                  label: 'Notice juridique',
                  ariaLabel: 'Notice juridique',
                  title: 'Notice juridique',
                  href: 'http://www.manuvie.com/Legal?ocmsLang=fr',
                  isExternal: true,
              },
              {
                  id: 'privacyPolic',
                  label: 'Politique de confidentialité',
                  ariaLabel: 'Politique de confidentialité',
                  title: 'Politique de confidentialité',
                  href: 'https://www.manuvie.ca/politiques-de-confidentialite.html',
                  isExternal: true,
              },
              {
                  id: 'accessibility',
                  label: 'Accessibilité',
                  ariaLabel: 'Accessibilité',
                  title: 'Accessibilité',
                  href: 'https://www.manuvie.ca/a-propos-de-nous/accessibilite.html',
                  isExternal: true,
              },
          ]
        : [
              {
                  id: 'manulife',
                  label: 'Manulife',
                  ariaLabel: 'Manulife',
                  title: 'Manulife',
                  href: 'https://manulife.ca',
                  isExternal: true,
              },
              {
                  id: 'legal',
                  label: 'Legal',
                  ariaLabel: 'Legal',
                  title: 'Legal',
                  href: 'http://www.manulife.com/Legal',
                  isExternal: true,
              },
              {
                  id: 'privacyPolicy',
                  label: 'Privacy Policy',
                  ariaLabel: 'Privacy Policy',
                  title: 'Privacy Policy',
                  href: 'https://www.manulife.ca/privacy-policies.html',
                  isExternal: true,
              },
              {
                  id: 'accessibility',
                  label: 'Accessibility',
                  ariaLabel: 'Accessibility',
                  title: 'Accessibility',
                  href: 'http://www.manulife.com/accessibility',
                  isExternal: true,
              },
          ];
